import React from 'react';
import { useHistory } from 'react-router-dom';
import { is8DataApp, pathname } from '../../../utils';
import { makeStyles } from '@material-ui/core/styles';
import { ReactComponent as Logo8fig } from '../../../../public/logos/8fig-logo-cyan.svg';
import { ReactComponent as Logo8data } from '../../../../public/logos/8data/8data-logo-white.svg';

const useStyles = makeStyles((theme: any) => ({
  root: {
    height: theme.spacing(9),
    backgroundColor: theme.palette.background.banner,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(7),
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(2),
    },
  },
  logo: {
    marginLeft: theme.spacing(2),
    '&:hover': {
      cursor: 'pointer',
    },
  },
  profileImg: {
    marginTop: theme.spacing(10),
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

//TODO: need to add to storybook
export default function Banner() {
  const history = useHistory();
  const classes = useStyles();
  const is8Data = is8DataApp();

  function handleClick() {
    history.push(pathname.preLogin.login.url);
  }

  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        {is8Data ? (
          <Logo8data onClick={handleClick} />
        ) : (
          <Logo8fig onClick={handleClick} />
        )}
      </div>
    </div>
  );
}
